export default class InerteRegistreAdmissionController {
	static $inject = ['$state', 'InerteRegistreAdmissionService', 'notification', '$translate', 'MOPService'];

	constructor($state, InerteRegistreAdmissionService, notification, $translate, MOPService) {
		this.$state = $state;
		this.InerteRegistreAdmissionService = InerteRegistreAdmissionService;
		this.notification = notification;
		this.$translate = $translate;
		this.MOPService = MOPService;

		this.ongletOpen = {
			isEnteteOpen: true
		};
		this.idSiteCommercial = null;
		this.idsSiteClient = [];
	}

	async $onInit() {
		this.MOPService.setMop([{ title: 'INERTES.BREADCRUMBS.INERTES_LIST', filename: 'GestionDesInertes.pdf', application: 'gestion' }]);
		this.getSiteCommercials();
	}

	async export() {
		if (!this.debut || !this.fin || !this.idSiteCommercial) {
			this.notification.error(this.$translate.instant('INERTES.VALIDATION.CHAMP_OBLIGATOIRE'));
			return;
		}
		if (this.debut > this.fin) {
			this.notification.error(this.$translate.instant('INERTES.VALIDATION.DATE_DEBUT_FIN'));
			return;
		}
		this.startLoading();
		let resultat;
		const fileName = Date.now();
		try {
			resultat = await this.InerteRegistreAdmissionService.export(
				this.idSiteCommercial,
				this.idsSiteClient.length > 0 ? this.idsSiteClient : [],
				this.debut,
				this.fin,
				fileName
			);
		} catch (ex) {
			this.notification.error(ex.data);
		} finally {
			this.stopLoading();
		}

		let data = resultat.data;
		let headers = resultat.headers;

		headers = headers();

		let contentType = headers['content-type'];

		let linkElement = document.createElement('a');
		try {
			const blob = new Blob([data], { type: contentType + ';charset=UTF-8' });
			const url = window.URL.createObjectURL(blob);
			linkElement.setAttribute('href', url);
			linkElement.setAttribute('download', fileName + '.xlsx');

			const clickEvent = new MouseEvent('click', {
				view: window,
				bubbles: true,
				cancelable: false
			});
			linkElement.dispatchEvent(clickEvent);
		} catch (ex) {
			this.notification.error(ex.data);
		} finally {
			this.stopLoading();
		}
	}

	async getSiteCommercials() {
		this.startLoading();
		try {
			this.siteCommercials = await this.InerteRegistreAdmissionService.getSiteCommercials();
		} catch (ex) {
			this.notification.error(ex.data);
		} finally {
			this.stopLoading();
		}
	}

	async getSiteClients() {
		if (!this.idSiteCommercial) {
			this.siteClients = [];
			return;
		}
		const siteCommercial = this.siteCommercials.find((site) => site.id == this.idSiteCommercial);
		if (!siteCommercial) {
			this.siteClients = [];
			return;
		}
		this.startLoading();
		try {
			this.siteClients = await this.InerteRegistreAdmissionService.getSiteClients(siteCommercial.idSociete);
		} catch (ex) {
			this.notification.error(ex.data);
		} finally {
			this.stopLoading();
		}
	}

	async handleSelectSiteCommercial(selectedSite) {
		if (selectedSite && selectedSite.length > 0) {
			this.idsSiteClient = [];
			this.selectedSiteClients = [];
			this.siteClients = [];
			this.idSiteCommercial = selectedSite[0].id;
			await this.getSiteClients();
		} else {
			this.idSiteCommercial = null;
			this.idsSiteClient = [];
			this.selectedSiteClients = [];
			this.siteClients = [];
		}
	}

	async handleSelectSiteClients(selectedClients) {
		if (selectedClients && selectedClients.length > 0) {
			this.idsSiteClient = selectedClients.map((site) => site.id);
			this.selectedSiteClients = selectedClients;
		} else {
			this.idsSiteClient = [];
			this.selectedSiteClients = [];
		}
	}

	reset() {
		this.idSiteCommercial = null;
		this.idsSiteClient = [];
		this.debut = null;
		this.fin = null;
	}

	annuler() {
		this.$state.go('gestion.home');
	}

	startLoading() {
		this.loading = true;
	}

	stopLoading() {
		this.loading = false;
	}
}
